import { useSelector } from "react-redux";

import Grid from "@mui/material/Grid2";

import GridSectionHeader from "../../widgets/GridSectionHeader";

import Death from "./Death.js";
import Disability from "./Disability.js";
import CriticalIllness from "./CriticalIllness.js";
import LongTermCare from "./LongTermCare.js";
import Hospitalisation from "./Hospitalisation.js";
import PersonalAccident from "./PersonalAccident.js";
import Pregnancy from "./Pregnancy.js";
import DependantNeeds from "./DependantNeeds.js";
import Retirement from "./Retirement.js";
import ChildrenEducation from "./ChildrenEducation.js";
import OtherPurpose from "./OtherPurpose.js";

export default function NeedsAnalysis() {
  //FINANCIAL OBJECTIVE - PROTECTION (From Redux)
  const familyAndAssets = useSelector(
    (state) => state.objectives.protection.familyAndAssets.priority
  );

  const disability = useSelector(
    (state) => state.objectives.protection.disability.priority
  );

  const criticalIlness = useSelector(
    (state) => state.objectives.protection.criticalIlness.priority
  );
  const longTermCare = useSelector(
    (state) => state.objectives.protection.longTermCare.priority
  );
  const hospitalization = useSelector(
    (state) => state.objectives.protection.hospitalization.priority
  );

  const personalAccident = useSelector(
    (state) => state.objectives.protection.personalAccident.priority
  );

  const pregnancy = useSelector(
    (state) => state.objectives.protection.pregnancy.priority
  );
  const dependantNeeds = useSelector(
    (state) => state.objectives.protection.dependantNeeds.priority
  );

  //FINANCIAL OBJECTIVE - WEALTH ACCUMULATION (From Redux)
  const retirementPlanning = useSelector(
    (state) => state.objectives.wealthaccumulation.retirementPlanning.priority
  );
  const childrenEducation = useSelector(
    (state) => state.objectives.wealthaccumulation.childrenEducation.priority
  );
  const otherPurpose = useSelector(
    (state) => state.objectives.wealthaccumulation.otherPurpose.priority
  );

  return (
    <>
      <Grid container spacing={2}>
        {/* NEEDS ANALYSIS */}
        <GridSectionHeader
          sectionName="NEEDS ANALYSIS"
          sx={{
            p: 1,
            pl: 1.8,
            mt: 0,
            mb: 1,
            fontSize: 18,
            fontWeight: "bold",
            color: "#FFFFFF", //WHITE
            // color: "#000000", //BLACK
            // backgroundColor: "#d9d9d9",
            backgroundColor: "#10B981",
          }}
        />

        {/*==============================
        NEEDS ANALYSIS - PROTECTION OBJECETIVES
        ==============================*/}
        {(familyAndAssets === "MEDIUM" || familyAndAssets === "HIGH") && (
          <Death />
        )}
        {(disability === "MEDIUM" || disability === "HIGH") && <Disability />}
        {(criticalIlness === "MEDIUM" || criticalIlness === "HIGH") && (
          <CriticalIllness />
        )}
        {(longTermCare === "MEDIUM" || longTermCare === "HIGH") && (
          <LongTermCare />
        )}
        {(hospitalization === "MEDIUM" || hospitalization === "HIGH") && (
          <Hospitalisation />
        )}
        {(personalAccident === "MEDIUM" || personalAccident === "HIGH") && (
          <PersonalAccident />
        )}
        {(pregnancy === "MEDIUM" || pregnancy === "HIGH") && <Pregnancy />}
        {(dependantNeeds === "MEDIUM" || dependantNeeds === "HIGH") && (
          <DependantNeeds />
        )}

        {/*==============================
        NEEDS ANALYSIS - WEALTH ACCUMULATION OBJECTIVES
        ==============================*/}
        {(retirementPlanning === "MEDIUM" || retirementPlanning === "HIGH") && (
          <Retirement />
        )}

        {(childrenEducation === "MEDIUM" || childrenEducation === "HIGH") && (
          <ChildrenEducation />
        )}

        {(otherPurpose === "MEDIUM" || otherPurpose === "HIGH") && (
          <OtherPurpose />
        )}
      </Grid>
    </>
  );
}
